/* eslint-disable max-len */
export default {
  ACTIONS: {
    BACK: 'Zurück',
    CANCEL: 'Abbrechen',
    CLOSE: 'Schließen',
    COLLECT: 'Abholen',
    CONFIRM: 'Bestätigen',
    NEW_USER: 'Neuer Benutzer',
    NEXT: 'Weiter',
    SAVE: 'Speichern',
    SCAN_QR_CODE: 'QR-Code lesen',
    SWIPE_DOWN: 'Nach unten wischen, um die Details auszublenden',
    SWIPE_UP: 'Nach oben wischen, um die Details anzuzeigen',
    WITHOUT_PIN: 'Du hast keinen PIN oder QR-Code? {link}.',
    WITHOUT_PIN_TO_COLLECT: 'Du hast keinen PIN? {link}'
  },
  ERRORS: {
    INVALID_CODE: 'Ungültiger Code.',
    INVALID_EMAIL: 'Ungültige E-Mail.',
    INVALID_NUMBER: 'Ungültige Nummer.',
    INVALID_PHONE: 'Ungültige Telefonnummer.',
    INVALID_USER: 'Ungültiger Benutzer.',
    ORDER_DELIVER_INVALID_CODE: 'Der {code} ist ungültig.',
    ORDER_DELIVERED: 'Die Bestellung wurde bereits zugestellt.',
    SOMETHING_WENT_WRONG: 'Ein Fehler ist aufgetreten!',
    UNABLE_TO_VALIDATE: 'Es war nicht möglich, die Bestellung zu bestätigen.',
    VALIDATING_CODE: 'Der Code {code} konnte nicht validiert werden.'
  },
  LABELS: {
    ACCEPT_RETURN:
      'Sind Sie sicher, dass Sie die Rücksendung akzeptieren möchten?',
    ALL_ORDERS: 'Alle anzeigen',
    ANOMALY: 'Anomalie?',
    CANCELED: 'Storniert',
    CLICK_HERE: 'Hier klicken',
    CLIENT_NAME: 'Kunde',
    COLLECT_ORDER: 'Bestellung zurücksenden',
    COLLECTS_NOT_FOUND: 'Keine Abholungen gefunden.',
    CUSTOMER_SIGNATURE: 'Unterschrift des Kunden',
    DATE_AND_HOUR: 'Datum und Uhrzeit',
    DELIVER_ORDER: 'Bestellung ausliefern',
    DELIVERED: 'Geliefert',
    EMAIL: 'E-Mail',
    ERROR: 'Fehler',
    IDENTITY_DOCUMENT: 'Ausweisdokument',
    IDENTITY_NAME: 'Name des Ausweisdokuments',
    IDENTITY_NUMBER: 'Ausweisnummer',
    NAME: 'Name',
    NEW_USER: 'Neuer Benutzer',
    NO_USERS: 'Noch kein Benutzer vorhanden.',
    NOT_DELIVERED: 'Nicht zugestellt',
    OR: 'Oder',
    ORDER_CODE: 'Bestellcode',
    ORDER_NUMBER: 'Bestellnummer',
    PACKAGE_NUMBER: 'Paketnummer',
    PACKAGES: 'Pakete',
    PACKAGES_CODES: 'Codes der Kisten',
    PACKAGES_DELIVERED: 'Pakete geliefert',
    PACKAGES_NUMBER: 'Anzahl der Packstücke',
    PACKAGES_RECEIVED: 'Pakete erhalten',
    PHONE: 'Telefonnummer',
    PHONE_EXAMPLE: ', Beispiel: +351999999999',
    PICK_UP_COLLECT_PIN: 'Rücksendungs-PIN',
    PICK_UP_NOT_FOUND: 'Keine Abholstelle gefunden.',
    PICK_UP_PIN: 'Abholcode',
    PICK_UP_SEARCH: 'Abholstelle finden',
    PICK_UP_SELECT: 'Abholstelle auswählen',
    PROCESSING: 'In Bearbeitung',
    READ_CLIENT_DELIVERY_QR_CODE: 'Abhol-QR-Code lesen',
    READ_PACKAGE_QR_CODE: 'QR-Code des Pakets lesen',
    RECEIVE_PACKAGES: 'Pakete erhalten',
    RECEIVED_BY: 'Empfangen von',
    RETURNED: 'Zurückgeschickt',
    RETURNS: 'Rücksendungen',
    SEARCH_FOR: 'Suchen',
    SELECT_DELIVER: 'Wähle eine zu liefernde Bestellung aus',
    SHOW_ALL: 'Alle',
    SHOW_IN_TRANSIT: 'In Transit',
    SHOW_PENDING: 'Ausstehend',
    STATE: 'Status',
    SUCCESS: 'Korrekt',
    TOTAL_ORDERS: 'Aufträge',
    TOTAL_PACKAGES: 'Pakete',
    TRACKING_NUMBER: 'Sendungsnummer',
    TYPE: 'Typ',
    TYPE_COLLECT: 'Abholungsauftrag',
    TYPE_DELIVERY: 'Lieferauftrag',
    USERS: 'Benutzer',
    WARNING: 'Hinweis',
    YOUR_ID: 'Deine ID: {id}'
  },
  SENTENCES: {
    COLLECT_PACKAGES: 'Bestellkarton(s) {trackingNumber}.',
    DELIVERED_PACKAGES:
      'Alle Pakete der Bestellung {trackingNumber} wurden gelesen.',
    HI: '👋 Hallo {name},',
    NO_DELIVERIES: 'Es liegen keine zu liefernden Bestellungen vor.',
    ORDER_TO_RETURN: 'Füllen Sie den PIN der zurückzusendenden Bestellung aus.',
    RECEIVED_PACKAGES: 'Alle Pakete wurden erhalten.',
    UNDELIVERED_PACKAGES:
      'Es gibt {total} ungelesene(s) Paket(e) der Bestellung {trackingNumber}.',
    UNRECEIVED_PACKAGES: 'Es gibt {total} nicht erhaltene(s) Paket(e).',
    WELCOME: 'Herzlich Willkommen. Was möchtest du tun?',
    WELCOME_WITH_PROZIS_POINTS:
      'Du hast bereits {prozisPoints} ProzisPoints gewonnen.',
    WITHOUT_SERVICE_POINTS:
      'Es sind keine Servicestellen zugeordnet. Die App wird nun geschlossen.'
  },
  SUCCESS: {
    CODE_READ: 'Code {code} erfolgreich gelesen.'
  }
};
